module.exports = __webpack_public_path__ + "static/media/leu.726b32af.png";